import React from "react";
import Container from "./Container.jsx";

export default function NewsGrid({ articles, heading = "News" }) {
  return (
    <section className="py-16 sm:py-24 bg-slate-50">
      <Container>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#003366]">{heading}</h2>
        <div className="mt-3 grid gap-3 md:grid-cols-1 lg:grid-cols-3">
          {articles.map((a) => (
            <article key={a.id} className="rounded-3xl bg-white shadow-sm ring-1 ring-slate-200 overflow-hidden">
              {/* Reserve space to avoid CLS */}
              <div className="w-full aspect-[16/9] overflow-hidden">
                <img
                  src={a.image}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="p-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-[#003366]">{a.category}</div>
                <h3 className="mt-1 text-lg font-semibold text-[#003366]">{a.title}</h3>
                <p className="mt-2 text-[#003366]">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-sm text-[#003366]">
                  <time dateTime={a.date}>
                    {new Date(a.date).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}
                  </time>
                  <a href={`#/article/${a.slug}`} className="font-semibold text-[#003366]">Read more →</a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
